import { Injectable } from '@angular/core'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { Observable, Subscription } from 'rxjs'
import { tap } from 'rxjs/operators'
import { EntityUpdateArgs, EntityUpdateRequest, PropertyChangeArgs, PropertyUpdate } from '../models/entity-update.model'

@UntilDestroy()
@Injectable()
export class EntityUpdateService {
  private pendingUpdates: EntityUpdateRequest

  private updateEntitySub: Subscription

  constructor() {
    this.initPendingUpdate()
  }

  updateEntity<T>(entityId: string, args: PropertyChangeArgs, callback: (id: string, request: EntityUpdateRequest) => Observable<T>): void {
    const properties = [...this.pendingUpdates.Properties, ...this.getPropertyUpdate(args)]
    this.pendingUpdates = { Properties: properties }
    const updates = this.mergeUpdates(this.pendingUpdates)

    const entityUpdateArgs = {
      EntityId: entityId,
      Request: updates,
    } as EntityUpdateArgs

    this.update<T>(entityUpdateArgs, callback)
  }

  private update<T>(args: EntityUpdateArgs, callback: (id: string, request: EntityUpdateRequest) => Observable<T>): void {
    if (this.updateEntitySub) {
      this.updateEntitySub.unsubscribe()
      this.updateEntitySub = null
    }

    this.updateEntitySub = callback(args.EntityId, args.Request)
      .pipe(tap({ next: () => this.initPendingUpdate() }), untilDestroyed(this))
      .subscribe()
  }

  private initPendingUpdate() {
    this.pendingUpdates = { Properties: [] }
  }

  private mergeUpdates = (update: EntityUpdateRequest): EntityUpdateRequest => {
    const properties: PropertyUpdate[] = []

    update.Properties.forEach(property => {
      const propertyDto = properties.find(p => p.Key === property.Key)

      if (propertyDto !== undefined) {
        propertyDto.Value = property.Value
      } else {
        properties.push(property)
      }
    })

    return { Properties: properties }
  }

  private getPropertyUpdate = (args: PropertyChangeArgs): PropertyUpdate[] => {
    if (!args) {
      return []
    }

    return [
      {
        Key: args.Key,
        Value: args.Value,
        MeasurementUnit: args.MeasurementUnitKey,
      } as PropertyUpdate,
    ]
  }
}
